import useProjectsApi from '../../../projects/projectsApi';

export type BlockStyle = {
  backgroundColor: string;
  fontColor: string;
  shadingColor: string;
  highlightColor: string;
  cardFontColor: string;
};

export type Theme = {
  coloredBackgroundBlock: BlockStyle;
  whiteBackgroundBlock: BlockStyle;
  grayBackgroundBlock: BlockStyle;
};

export type DomainDto = {
  subdomain: string;
};

export type Branding = {
  logoFileId?: number;
  _logoUrl?: {
    resized: string;
    full: string;
  };
  mobileLogoFileId?: number;
  _mobileLogoUrl?: {
    resized: string;
    full: string;
  };
  theme: Theme;
};

export type UpdateThemeRequest = {
  theme: Theme;
};

export type UpdateLogosRequest = {
  logoFileId?: number;
  mobileLogoFileId?: number;
}

export default function useClientPortalService() {
  const nekstApi = useProjectsApi();

  const getDomain = async () => {
    return await nekstApi.get('/settings/clientportal/domain') as DomainDto;
  };

  const updateDomain = async (subdomain: string) => {
    return await nekstApi.post('/settings/clientportal/domain', { subdomain }) as DomainDto;
  };

  const getBranding = async () => {
    return await nekstApi.get('/settings/clientportal/branding') as Branding;
  };

  const updateBranding = async (request: UpdateThemeRequest) => {
    return await nekstApi.post('/settings/clientportal/branding/theme', request) as Branding;
  };

  const updateLogos = async (request: UpdateLogosRequest) => {
    return await nekstApi.post('/settings/clientportal/branding/logos', request) as Branding;
  }

  return {
    getDomain,
    updateDomain,
    getBranding,
    updateBranding,
    updateLogos,
  };
}
